import { lazy } from 'react';

import { wait } from 'utils/wait';

export const lazyWithRetry = (componentImport: any) =>
    lazy(async () => {
        try {
            return await componentImport();
        } catch (error) {
            // Retry with delay to handle possible network issue.
            try {
                await wait(1000);
                return await componentImport();
            } catch (error) {
                const pageForceRefreshTime = localStorage.getItem('pageForcedRefreshTime');
                if (pageForceRefreshTime && +pageForceRefreshTime > new Date().getTime() - 60000) {
                    // Already reloaded - user is using the latest version of the application - throw error and crush.
                    throw error;
                }

                // Reload to handle possible issue with old app version cached.
                localStorage.setItem('pageForcedRefreshTime', '' + new Date().getTime());
                return window.location.reload();
            }
        }
    });
